/**
 * When the help opens by itself (part 11b, table V): once per device record and guide version (the user's choice,
 * 2026-10-07: again when the guide changes), on the workspace while it is editable (so
 * the device's flag can be stored, part 11's W1), with no Home Screen screen (part 40a, H2) and no dialog showing.
 */
import type { Screen } from '../shell/screen.ts';

/** What the rule reads of the app. */
export interface VisitState {
  readonly screen: Screen;
  readonly editable: boolean;
  /** The Home Screen screen covers the workspace (H2). */
  readonly asking: boolean;
  /** A dialog is showing. */
  readonly dialog: boolean;
  /** The device's `helpSeen` setting: the guide version the help last showed, or null. */
  readonly helpSeen: string | null;
  /** The version of the guide the help would show now. */
  readonly version: string;
}

/** V1–V9: whether the help opens by itself now. */
export function opensHelp(state: VisitState): boolean {
  return state.screen === 'workspace' && state.editable && !state.asking && !state.dialog && state.helpSeen !== state.version;
}
